export default __webpack_public_path__ + "static/media/illustration.b19d5c52.svg";